export default {
    SCREEN: 'screen',
    IS_ADVANCED_DIAGNOSTIC: 'isAdvancedDiagnostic',
    SOURCE: 'source',
    LANGUAGE: 'l',
    MODAL: 'modal',
    DEVICE_TYPE: 'deviceType',
    IS_AGE_CONFIRMED: 'is_age_confirmed',
    TNC_PAGE_TYPE: 'type',
};
